<template>
    <div class="user-settings-page-component-container">
        <div class="component-wrapper">
            <AppHeader />
            <ChangeAppLanguage v-if="showChangeAppLanguagePage" :closeChangeAppLanguagePageHandle="closeChangeAppLanguagePageHandle"/>

            <div v-else class="user-settings-page-container">
                <div v-if="loadingPage" class="spinner-container">
                    <div class="spinner">
                        <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                    </div>
                </div>
                <div v-if="successLoadingPage && !loadingPage" class="user-settings-list-container">
                    <div class="user-settings-list-wrapper">
                        <ul class="user-settings-list">
                            <li v-for="(setting, index) in settingsList" class="list-item btn" :key="index"
                                @click="setting.action()">
                                <div class="setting-btn">{{ $t(`${setting.title}`) }}</div>
                            </li>
                        </ul>
                    </div>

                    <div class="log-out-btn-container btn">
                        <div class="log-out-btn-wrapper">
                            <!-- <div class="log-out-btn btn" @click="logOutHandle">Log out</div> -->
                            <div class="log-out-btn" @click="logOutHandle">{{ $t('log_out') }}</div>
                        </div>
                    </div>

                    <div class="delete-account-btn-container btn" @click="showDeletingAccountPopupHandle">
                        <div class="delete-account-btn-wrapper">
                            <!-- <div class="log-out-btn btn" @click="logOutHandle">Log out</div> -->
                            <div class="delete-account-btn" >{{ $t('delete_account') }}</div>
                        </div>
                    </div>
                </div>
                <div v-if="failedLoadingPage" class="fialed-loading-page-container">
                    <div class="info-text-container">
                        <p class="info-text">
                            {{ $t('something_went_wrong_try_again') }}
                        </p>
                    </div>
                    <div class="reload-btn-container">
                        <div class="reload-btn" @click="reloadPage">{{ $t('reload') }}</div>
                    </div>
                </div>
            </div>


            <AppFooter />
        </div>

        <ConfirmDeleteAccountPage v-if="showDeletingAccountPopup" :errorTypingDelete="errorTypingDelete" 
            :closeDeletingAccountPopupHandle="closeDeletingAccountPopupHandle" :loadingEventAction="loadingEventAction"
            :deleteAccount="deleteAccount" :showDeleteAccountMsg="showDeleteAccountMsg"
        />

    </div>
</template>

<script>
import AppHeader from './AppHeader.vue';
import AppFooter from './AppFooter.vue';
import ConfirmDeleteAccountPage from './ConfirmDeleteAccountPage.vue';
import ChangeAppLanguage from './ChangeAppLanguage.vue';

export default {
    name: 'UserSettingsPage',
    components: {
        AppHeader,
        AppFooter,
        ConfirmDeleteAccountPage,
        ChangeAppLanguage,
    },
    data() {
        return {
            settingsList: [
                {
                    title: "change_language",
                    action: () => this.showChangeAppLanguagePageHandle(),
                },
                {
                    title: "change_password",
                    action: () => this.clickHandle("/change-password"),
                },
            ],
            loadingPage: true,
            successLoadingPage: false,
            failedLoadingPage: false,
            showDeleteAccountMsg: false,
            showDeletingAccountPopup: false,
            errorTypingDelete: false,
            loadingEventAction: false,
            showChangeAppLanguagePage: false,
        };
    },
    methods: {
        logOutHandle: async function () {
            await this.$store.logOut();
            this.$router.push("/login");
        },
        clickHandle: function (url) {
            this.$router.push(url);
        },
        showDeletingAccountPopupHandle: function() {
            this.showDeletingAccountPopup = true;
        },
        closeDeletingAccountPopupHandle: function() {
            this.loadingEventAction = false;
            this.errorTypingDelete = false;
            this.showDeletingAccountPopup = false;
        },
        deleteAccount: async function(enteredInputText) {
            this.loadingEventAction = true;

            const translatedDeleteWord = this.$t('delete').toUpperCase();

            // console.log("enteredInputText: " + enteredInputText);
            // console.log("translatedDeleteWord: " + translatedDeleteWord);

            if (enteredInputText !== translatedDeleteWord) {
                this.loadingEventAction = false;
                this.errorTypingDelete = true;
            }
            else {
                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    try {
                        const { email, token } = localStorageUser;
                        const id = this.$store.user.zohoId;
                        const data = {
                            email: email,
                            token: token,
                            id: id,
                        };

                        const deleteAccountResponse = await fetch('../../api/user/deleteAccount', {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json; charset=UTF-8',
                            },
                            body: JSON.stringify(data),
                        });

                        const deleteAccountResponseJson = await deleteAccountResponse.json();

                        if (!deleteAccountResponseJson.status) {
                            if (deleteAccountResponseJson.invalidToken) {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'logout';
                                this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                                this.$store.mustLogOut = true;
                            }
                            else {
                                this.$store.showErrorPopup = true;
                                this.$store.errorPopupTitle = 'action_failed';
                                this.$store.errorPopupMsg = deleteAccountResponseJson.message;
                                this.loadingEventAction = false;
                            }
                        }
                        else {
                            this.showDeleteAccountMsg = false;
                            this.closeDeletingAccountPopupHandle();
                            this.loadingEventAction = false;
                            // this.showDeleteAccountMsg = true;
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'success';
                            this.$store.errorPopupMsg = deleteAccountResponseJson.message;
                            this.$store.mustLogOut = true;
                        }
                    }
                    catch(err) {
                        console.log("Error deleting account...");
                        console.log(err);
                        this.showDeleteAccountMsg = false;
                        this.$store.showErrorPopup = true;
                        this.$store.errorPopupTitle = 'unexpected_error';
                        this.$store.errorPopupMsg = 'something_went_wrong_try_again';
                        this.loadingEventAction = false;
                    }
                }
            }
        },
        showChangeAppLanguagePageHandle: function() {
            this.showChangeAppLanguagePage = true;
        },
        closeChangeAppLanguagePageHandle: function() {
            this.showChangeAppLanguagePage = false;
        },
    },
    async created() {
        if (!this.$store.user.zohoId) {
            try {
                const localStorageUser = JSON.parse(localStorage.getItem('user'));
                if (!localStorageUser || !localStorageUser.email || !localStorageUser.token) {
                    this.$store.showErrorPopup = true;
                    this.$store.errorPopupTitle = 'logout';
                    this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                    this.$store.mustLogOut = true;
                }
                else {
                    const { email, token } = localStorageUser;
                    const userAuth = await this.$store.authUser(email, token);
                    if (!userAuth.status) {
                        if (userAuth.confirmWarning) {
                            this.$store.unconfirmedAccount = true;
                            this.$store.showFooterBackBtn = true;
                            this.$store.user.email = email;
                            this.$router.push('/confirm');
                        }
                        else if (userAuth.error) {
                            this.$store.showMainErrorPage = true;
                        }
                        else {
                            this.$store.showErrorPopup = true;
                            this.$store.errorPopupTitle = 'logout';
                            this.$store.errorPopupMsg = 'expired_session_try_to_login_again';
                            this.$store.mustLogOut = true;
                        }
                    }
                    else {
                        this.successLoadingPage = true;
                        this.loadingPage = false;
                    }
                }
            }
            catch(err) {
                console.log(err);
                this.failedLoadingPage = true;
                this.loadingPage = false;
                // this.failedLoadingPage = true;
                // this.loadingPage = false;
                // this.$store.showMainErrorPage = true;
            }
        }
        else {
            this.successLoadingPage = true;
            this.loadingPage = false;
        }
    }
}
</script>

<style>
.user-settings-page-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.user-settings-page-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.user-settings-page-component-container .user-settings-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.user-settings-page-component-container .spinner-container {
    flex: 1;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.user-settings-page-component-container .spinner {
    width: 20% !important;
    max-width: 100px !important;
}

.user-settings-page-component-container .user-settings-list-container {
    position: relative;
    width: 88%;
    max-width: 500px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.user-settings-page-component-container .user-settings-list-wrapper {
    width: 100%;
}

.user-settings-page-component-container .user-settings-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    /* padding: 25px 0; */
    /* border: 1px solid red; */
}

.user-settings-page-component-container .list-item {
    margin-bottom: 20px;
    background: #656361;
}

[dir="rtl"] .user-settings-page-component-container .list-item,
[dir="rtl"] .user-settings-page-component-container .log-out-btn-container,
[dir="rtl"] .user-settings-page-component-container .delete-account-btn-container {
    max-height: 38px;
}

.user-settings-page-component-container .list-item:hover {
    cursor: pointer;
    background: #92d400;
}

.user-settings-page-component-container .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 350px;
    border-radius: 30px;
    padding: 5px 0;
    cursor: pointer;
    text-align: center;
    color: #ffffff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 30px;
    /* border: 1px solid red; */
}

.user-settings-page-component-container .log-out-btn-container {
    background: #009df4;
}

.user-settings-page-component-container .log-out-btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.user-settings-page-component-container .delete-account-btn-container {
    position: absolute;
    bottom: 25px;
    background: #cb061d;
}

.user-settings-page-component-container .fialed-loading-page-container {
    flex: 1;
    width: 100%;
    max-width: 500px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.user-settings-page-component-container .info-text-container {
    width: 100%;
    max-width: 475px;
    padding: 5% 0 25px;
}

.user-settings-page-component-container .info-text-container .info-text {
    font-size: 29px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 32px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.user-settings-page-component-container .reload-btn-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
}

.user-settings-page-component-container .reload-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

@media (max-width: 426px) {
    .user-settings-page-component-container .setting-btn,
    .user-settings-page-component-container .log-out-btn,
    .user-settings-page-component-container .delete-account-btn {
        font-size: 24px;
    }

    .user-settings-page-component-container .info-text-container .info-text {
        font-size: 26px;
    }

    .user-settings-page-component-container .reload-btn {
        font-size: 24px;
    }
}

@media (max-width: 320px) {
    .user-settings-page-component-container .setting-btn,
    .user-settings-page-component-container .log-out-btn,
    .user-settings-page-component-container .delete-account-btn {
        font-size: 20px;
    }
}
</style>